import { render, staticRenderFns } from "./receive-manager.vue?vue&type=template&id=53e41468&scoped=true&"
import script from "./receive-manager.vue?vue&type=script&lang=js&"
export * from "./receive-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e41468",
  null
  
)

export default component.exports